import Icon from 'icons/Icon';
import React, { Component } from 'react';
import { Syntax } from '@trlogic/ui-pack';
import ChartElasticExpressionComponent from './ChartElasticExpressionComponent';
import { RootState } from '../../../../redux/store';
import { ChartState } from '../../../../redux/reducers/ChartReducer';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import ChartArchiosExpressionComponent from './ChartArchiosExpressionComponent';

class MetricFilterItem extends Component<Props, State> {
  public state = new State();

  render() {
    const { collapse } = this.state;
    const { syntax, header, isElasticExpression } = this.props;
    return (
      <div className={'flex flex-col w-full h-full overflow-x-scroll flex-shrink-0'}>
        <div onClick={this.toggleCollapse} className={`flex items-center gap-x-1 hover:cursor-pointer`}>
          <Icon icon={'arrow-right'} className={'text-primary'} size={16} />
          <p className={'text-f-purple text-sm'}>{header}</p>
        </div>
        <div className={`${collapse ? 'flex' : 'hidden'} px-5 py-5 border rounded-[4px] bg-[#fafafa]`}>
          {isElasticExpression ? (
            <ChartElasticExpressionComponent
              id={header}
              syntax={syntax}
              variables={this.props.chart.expressionVariables}
              onChangeSyntax={this.onChangeSyntax}
            />
          ) : (
            <ChartArchiosExpressionComponent
              syntax={syntax}
              variables={this.props.chart.expressionVariables}
              onChangeSyntax={this.onChangeSyntax}
              id={header}
            />
          )}
        </div>
      </div>
    );
  }

  private onChangeSyntax = (updatedExpression: Syntax): void => {
    const { onChangeSyntax } = this.props;
    onChangeSyntax(updatedExpression);
  };

  private toggleCollapse = () => {
    this.setState({ collapse: !this.state.collapse });
  };
}

interface Props extends ReduxProps {
  syntax: Syntax;
  onChangeSyntax: (syntax: Syntax) => void;
  header: string;
  isElasticExpression: boolean;
}

const mapStateToProps = (state: RootState) => ({
  chart: state.chart as ChartState,
});
const mapDispatchToProps = {};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

class State {
  collapse: boolean = false;
}

export default connector(MetricFilterItem);
